
import Breadcrumbs from '~/components/UI/Breadcrumbs';
import ImageComponent from '~/components/product/Image';
import InformationComponent from '~/components/product/Information';
import ProductMixin from '~/node_modules/sitis-nuxt/lib/mixins/ProductMixin';

export default {
  name: 'Slug',

  fetch: async function () {
    await this.loadProduct();
    await this.getSameProduct();
    await this.getRelatedProduct();
  },

  head: function () {
    const title = this.product?.seo?.title || this.product?.name;
    const description = this.product?.seo?.description || '';
    return this.$seoMetaHelper({
      title: title,
      description: description,

      meta: [
        {
          name: 'og:title', hid: 'og:title', property: 'og:title', content: title,
        },

        { name: 'description', hid: 'metadescription', content: description },
        {
          name: 'og:description', hid: 'og:description', property: 'og:description', content: description,
        },
      ],
    });
  },

  data: function () {
    return {
      reviews: [],
      sameProduct: [],
      relatedProduct: [],
      recentlyProduct: [],

      isLoadReviews: false,
      isLoadRecentlyProduct: false,
    };
  },

  mixins: [
    ProductMixin,
  ],

  computed: {
    breadcrumbs: function () {
      const fullUrlCatalog = (this.product?.categories || []).map((t) => t.slug).filter((t) => !!t).join('/');
      const lastCategory = [...(this.product?.categories || [])].pop();
      const parent = this.product?.productSetParents?.[0] || null;
      const brand = this.product?.brand || {};

      const list = [
        { title: 'Главная', path: '/' },
        { title: lastCategory?.name, path: `/catalog/${lastCategory?.slug}` },
      ];
      if (Object.keys(brand || {}).length > 0) {
        list.push({
          title: brand?.name, path: `/${fullUrlCatalog}/f/brand=${(brand?.url || '').split('/').pop()}`,
        });
      }

      if (parent) {
        list.push({
          title: parent?.name,
          path: parent?.url,
        });
      }

      return [
        ...list,
        { title: this.product?.name, path: this.$route.path },
      ];
    },
    isLoadign: function () {
      return Boolean(
        this.$store.state.appState?.loading?.product,
      );
    },
    pageH1: function () {
      return this.product?.dynamicFields?.seo_heading || this.product?.shortDescription || this.product?.name;
    },
    productCode: function () {
      return this.$productSku(this.product);
    },
    metaDescription: function () {
      return this.product?.seo?.description || '';
    },

    afterCmsPageId: function () {
      return Number.parseFloat(this.$store.state.appState?.vars?.['CMS PAGE ID для товара'] || 0);
    },

    extensions: function () {
      return ['productSetParents', 'seo_heading', 'characteristicGroup'];
    },

    filterPageBlockValue: function () {
      return {
        extras: {
          products: this.relatedProduct,
        },
      };
    },

    isAvaibleCountProduct: function () {
      return Boolean((this.product?.quantity || 0) > 0 && !this.product.isNotAvailable);
    },
  },

  components: {
    Breadcrumbs,
    ImageComponent,
    InformationComponent,
    TabContentComponent: () => import('~/components/product/TabContent'),
    DescriptionSection: () => import('~/components/product/DescriptionSection'),
    Promotions: () => import('~/components/product/Promotions'),
  },

  watch: {
    product: async function () {
      // await this.getSameProduct();
      // await this.getRelatedProduct();

      await this.getReviews();
      await this.getRecentlyProduct();
    },
  },

  mounted: async function () {
    await this.getReviews();
    await this.getRecentlyProduct();
  },

  methods: {
    getReviews: async function () {
      if (!this.product || this.isLoadReviews) {
        return;
      }

      this.isLoadReviews = true;
      const url = `/reviews?filter[model]=Product&filter[model_key]=${this.product?.id}`;
      const response = await this.$api.agent.transport.get(url).then((res) => res.data).catch(() => []);
    },
    getSameProduct: async function () {
      if (!this.product) {
        return;
      }
      const response = await this.$api.agent.transport.get(`/products/${this.product.slug}/same?expand=short_characteristics`).then((res) => res.data).catch(() => []);
      this.sameProduct = response;
    },
    getRelatedProduct: async function () {
      if (!this.product) {
        return;
      }
      const response = await this.$api.agent.transport.get(`/products/${this.product.slug}/related?expand=short_characteristics`).then((res) => res.data).catch(() => []);
      this.relatedProduct = response;
    },
    getRecentlyProduct: async function () {
      if (!this.product || this.isLoadRecentlyProduct) {
        return;
      }
      this.isLoadRecentlyProduct = true;
      const response = await this.$api.agent.transport.get('/recently-viewed?expand=short_characteristics').then((res) => res.data).catch(() => []);
      this.recentlyProduct = response;
    },

    loadProduct: async function () {
      const [slug] = this.$route.path.split('/').reverse();
      const requestParams = {
        slug,
        extensions: this.extensions || [],
      };
      const product = await this.getProduct(requestParams);
      if (product) {
        this.product = JSON.parse(JSON.stringify(product));
        this.addModifierSet(product.id, 1);
      } else {
        this.$nuxt.context.redirect(301, '/');
      }
    },
  },
};
